import React, { Component } from 'react';
import { Modal, Button, Tag, Table, Popconfirm, message, Icon, Tooltip } from 'antd';
import { withRouter } from 'react-router';
import { capitalize, isInArray } from 'store/utility';
//import styles from './CartModal.module.css'
import PromoSelector from 'components/Promo/PromoSelector';

class CartModal extends Component {
  state = {
    contents: 'cartItems',
    invalids: [],
  };

  renderType = row => {
    switch (row) {
      case 'tiles':
        return <Tag color="magenta">{capitalize(row)}</Tag>;
      case 'stone':
        return <Tag color="red">{capitalize(row)}</Tag>;
      case 'mosaic':
        return <Tag color="volcano">{capitalize(row)}</Tag>;
      case 'wood':
        return <Tag color="orange">{capitalize(row)}</Tag>;
      case 'vinyl':
        return <Tag color="gold">{capitalize('BNK')}</Tag>;
      case 'countertop':
        return <Tag color="purple">{capitalize(row)}</Tag>;
      default:
        throw new Error('Unfound product_type');
    }
  };

  renderImage = row => <img width="50" height="50" src={row.image_url} alt="" />;

  deleteHandler = (type, id) => {
    this.props.trimCart(type, id);
    return;
  };

  renderTitle = record => {
    const { invalids } = this.state;
    if (this.state.invalids.length > 0 && isInArray(invalids, record.id)) {
      return (
        <span style={{ color: 'red' }}>
          <Tooltip placement="left" title={'Duplicate in QR code, please remove.'}>
            <Icon style={{ fontSize: '18px' }} type="exclamation-circle" />
          </Tooltip>
          <span
            style={{
              marginRight: '5px',
            }}
          >
            &nbsp;
          </span>
          <strong>{record.title}</strong>
        </span>
      );
    } else {
      return <span>{record.title}</span>;
    }
  };

  columns = () => {
    return [
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        width: 225,
        render: (text, record) => this.renderTitle(record),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 200,
      },
      {
        title: 'Price',
        dataIndex: 'price_format',
        key: 'price_format',
        width: 100,
      },
      {
        title: 'Stock',
        dataIndex: 'stock_level',
        key: 'stock_level',
        width: 100,
      },
      {
        title: 'Type',
        dataIndex: 'product_type',
        key: 'product_type',
        render: row => this.renderType(row),
        width: 80,
      },
      {
        title: 'Image',
        key: 'image_url',
        render: row => this.renderImage(row),
        width: 80,
      },
      {
        dataIndex: 'delete',
        align: 'center',
        render: (_u, record) => {
          const { product_type: pt, id } = record;
          return (
            <a>
              <Icon type="cross" onClick={() => this.deleteHandler(pt, id)} />
            </a>
          );
        },
      },
    ];
  };

  confirmClearHandler = e => {
    const { clearCart } = this.props;
    if (clearCart()['type'] === 'CLEAR_CART_END') message.success('Cleared Cart');
    else throw new Error('woops could not clear cart');
  };

  togglePromoSelector = e => {
    if (this.state.contents === 'promoSelector') {
      this.setState(prev => ({ ...prev, contents: 'cartItems' }));
    } else {
      this.setState(prev => ({ ...prev, contents: 'promoSelector' }));
      this.props.fetchPromos();
    }
  };

  confirmQRHandler = e => {
    const { sendToQRcode, data, history } = this.props;
    // send only referential id
    const invalidIDs = sendToQRcode(data);
    if (invalidIDs.length > 0) {
      message.error('Item(s) already present in QR code');
      this.setState(prev => ({ ...prev, invalids: invalidIDs }));
    } else {
      message.success('Added to QR codes');
      history.push('/qr_codes');
    }
  };

  render() {
    const { data, handleSaveToPromo, fetchPromos, promos } = this.props;
    return (
      <Modal
        title="My Cart"
        width={900}
        visible={this.props.visible}
        onCancel={this.props.toggleModal}
        footer={
          <div>
            <Popconfirm
              key="clear"
              title="Are you sure you want to clear your cart?"
              okText="Yes"
              cancelText="No"
              onConfirm={this.confirmClearHandler}
            >
              <Button type="danger">Clear Cart</Button>
            </Popconfirm>
            <Button onClick={this.togglePromoSelector}>
              {this.state.contents === 'cartItems' ? 'Add to Promotion...' : 'Back to cart items'}
            </Button>
            <Popconfirm
              key="qrcodes"
              title="Confirm addition to QR codes"
              okText="Confirm"
              cancelText="No"
              onConfirm={this.confirmQRHandler}
            >
              <Button>Add QR codes</Button>
            </Popconfirm>
          </div>
        }
      >
        {this.state.contents === 'promoSelector' ? (
          <PromoSelector promos={promos} handleSave={handleSaveToPromo} fetchPromos={fetchPromos} />
        ) : (
          <Table
            columns={this.columns()}
            rowKey={record => record.id}
            size="small"
            bordered
            dataSource={data}
            pagination={false}
            scroll={data.length > 6 ? { y: 400 } : {}}
          />
        )}
      </Modal>
    );
  }
}

export default withRouter(CartModal);



// WEBPACK FOOTER //
// ./src/components/Cart/Modal/CartModal.js